import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

/** RTK Query's error and diagnostics, with the API's display fields ready for callers. */
export type ApiError = FetchBaseQueryError & {
    message?: string;
    code?: string;
};

/** Distinguish returned request failures from exceptions thrown by other SDKs. */
export function isApiError(error: unknown): error is ApiError {
    return typeof error === "object" && error !== null && "status" in error;
}

/** Request setup can throw before fetchBaseQuery returns an error (for example, token refresh). */
export function apiErrorFromException(error: unknown): ApiError {
    return {
        status: "CUSTOM_ERROR",
        error: error instanceof Error ? error.message : "Request setup failed",
    };
}

/** Normalize at the base-query boundary; keep the original payload for validation and diagnostics. */
export function normalizeApiError(error: FetchBaseQueryError): ApiError {
    const data = error.data;
    if (typeof data !== "object" || data === null) return error;

    return {
        ...error,
        ...("message" in data && typeof data.message === "string"
            ? { message: data.message }
            : {}),
        ...("error" in data && typeof data.error === "string"
            ? { code: data.error }
            : {}),
    };
}
